import { HttpClient, HttpParams, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiResponse } from '@shared';
import { IPaginationParams } from '../interfaces/IPaginationParamas';

@Injectable({
  providedIn: 'root',
})
export class ReferralService {
  constructor(private http: HttpClient) {}

  /** Branch referral link + QR (PNG data URI) for a user, generated server-side. */
  getReferralLink(userId: string) {
    return this.http.get<ApiResponse>(`/v1/admin/referral/link/${userId}`);
  }

  /** Paginated list of users who registered through `referrerId` (Referrals tab). */
  getReferrals(referrerId: string, params: IPaginationParams) {
    let httpParams = new HttpParams();
    if (params) {
      Object.keys(params).forEach((key) => {
        httpParams = httpParams.append(key, String((params as any)[key]));
      });
    }
    params?.columnFilters?.forEach((ele) => {
      const [key, value] = Object.entries(ele)[0];
      httpParams = httpParams.set(key, (value as any)?.$regex);
    });
    return this.http.get<ApiResponse>(`/v1/admin/referral/list/${referrerId}`, {
      params: httpParams,
    });
  }

  /** Excel/CSV of ALL referrals across every user (global export). */
  exportReferralData() {
    const options = {
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.get<HttpResponse<Blob>>(`/v1/admin/referral/export`, options);
  }

  /** Excel/CSV of a single referrer's referrals (Referrals tab export). */
  exportReferralsByReferrer(referrerId: string) {
    const options = {
      observe: 'response' as 'body',
      responseType: 'blob' as 'json',
    };
    return this.http.get<HttpResponse<Blob>>(
      `/v1/admin/referral/export/${referrerId}`,
      options,
    );
  }
}
